"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewAssetIdentification extends new_item_1.default {
    constructor(newAssetIdentification) {
        super();
        this.assetId = newAssetIdentification.assetId;
    }
}
exports.default = NewAssetIdentification;
//# sourceMappingURL=new-assetIdentification.js.map